import { str } from 'envalid';

export const nodeEnvSpec = str({
  choices: ['development', 'production', 'test'] as const,
  default: 'development',
});
